"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var environment_guard_exports = {};
__export(environment_guard_exports, {
  default: () => environment_guard_default
});
module.exports = __toCommonJS(environment_guard_exports);
var t = __toESM(require("@babel/types"), 1);
var GUARD_SPECIFIERS = [
  "server-only",
  "client-only",
  "native-only",
  "web-only"
];
var ALLOWED_IN_NATIVE = [
  "native-only"
];
function environmentGuardBabelPlugin(_) {
  return {
    name: "one-environment-guard",
    visitor: {
      ImportDeclaration(path) {
        var source = path.node.source.value;
        if (!GUARD_SPECIFIERS.includes(source)) return;
        if (ALLOWED_IN_NATIVE.includes(source)) {
          path.remove();
        } else {
          path.replaceWith(t.throwStatement(t.newExpression(t.identifier("Error"), [
            t.stringLiteral(`${source} cannot be imported in a native environment`)
          ])));
        }
      }
    }
  };
}
var environment_guard_default = environmentGuardBabelPlugin;
//# sourceMappingURL=environment-guard.js.map
